module.exports = __webpack_public_path__ + "img/Feature.d1650c35.png";